import { useState, useEffect } from 'react';
import {
    Activity,
    Code2,
    Globe,
    Database,
    Radar,
    GitBranch,
    ArrowRight,
    CheckCircle2,
} from 'lucide-react';

import { useNavigate } from 'react-router-dom';
const skillGroups = [
    {
        title: 'Langages',
        icon: Code2,
        items: ['Java', 'PHP', 'Javascript','Linux /Unix', 'Shell / Bash'],
    },
    {
        title: 'Développement web',
        icon: Globe,
        items: ['Spring Boot', 'ReactJS', 'REST & SOAP', 'Postman / Swagger'],
    },
    {
        title: 'Bases de données',
        icon: Database,
        items: ['Oracle', 'SQL', 'MongoDB'],
    },
    {
        title: 'Supervision & production monétique',
        icon: Radar,
        items: ['Zabbix / Nagios', 'PowerCARD', '$UNIVERS / TSO IBM', 'T24/Nacom', 'CFT', 'Jenkins', 'GLPI / EasyVista'],
    },
    {
        title: 'Versioning & analyse',
        icon: GitBranch,
        items: ['Git (CI/CD)', 'Power BI'],
    },
];

export default function Home() {
    const [visible, setVisible] = useState(false);
    useEffect(() => setVisible(true), []);

    const navigate = useNavigate();

    return (
        <>
            <style>{css}</style>

            <div className={`page ${visible ? 'is-visible' : ''}`}>

                <div className="status-bar">
                    <span className="status-dot" />
                    <span className="status-text">SYSTEME OPERATIONNEL</span>
                    <span className="status-sep">/</span>
                    <span className="status-text">SLA 99.9%</span>
                    <span className="status-sep">/</span>
                    <span className="status-text">4 ANS — SUPPORT PRODUCTION MONETIQUE</span>
                </div>

                <section className="hero">
                    <div className="hero-left">
                        <span className="eyebrow">Mahjoubi Mohammed — Ingénieur Support & Production IT</span>
                        <h2>
                            4 ans d'expérience en support production sur des environnements bancaires critiques<br />
                            supervision des flux monétiques, résolution d'incidents, optimisation
                            des alertes et respect des engagements de service.
                        </h2>
                        <p className="lead">

                        </p>
                        <div className="cta">
                            <button className="btn-primary" onClick={() => navigate('/contact')}>
                                Me contacter <ArrowRight size={18} />
                            </button>
                            <button className="btn-secondary" onClick={() => navigate('/projet')}>
                                Voir mes projets
                            </button>
                        </div>
                    </div>

                    <div className="hero-right">
                        <div className="panel">
                            <div className="panel-head">
                                <span className="panel-dot red" />
                                <span className="panel-dot amber" />
                                <span className="panel-dot green" />
                                <span className="panel-title">monitoring.log</span>
                            </div>
                            <div className="panel-body">
                                <div className="log-line ok"><CheckCircle2 size={14} /> Switch monétique</div>
                                <div className="log-line ok"><CheckCircle2 size={14} /> Traitement batch </div>
                                <div className="log-line ok"><CheckCircle2 size={14} /> Flux CFT — cohérence vérifiée</div>
                                <div className="log-line warn"><Activity size={14} /> Alerte Zabbix/Nagios — analysée, cause racine identifiée</div>
                                <div className="log-line ok"><CheckCircle2 size={14} /> Ticket GLPI #4471 — résolu (niveau 2)</div>
                                <div className="cursor">_</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="skills">
                    <span className="eyebrow center">Compétences</span>
                    <h2>Deux métiers, une seule exigence : la fiabilité</h2>

                    <div className="skills-grid">
                        {skillGroups.map((group) => {
                            const Icon = group.icon;
                            return (
                                <div key={group.title} className="skill-card">
                                    <div className="skill-head">
                                        <Icon size={20} strokeWidth={1.75} />
                                        <h3>{group.title}</h3>
                                    </div>
                                    <ul>
                                        {group.items.map((item) => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            );
                        })}
                    </div>
                </section>

                <section className="cta-section">
                    <h2>Un incident à résoudre ? Un projet à construire ?</h2>
                    <p>Discutons de vos besoins en support monétique ou en développement.</p>
                    <button className="btn-primary" onClick={() => navigate('/contact')}>
                        Me contacter <ArrowRight size={18} />
                    </button>
                </section>
            </div>
        </>
    );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');

.page {
  --bg: #0A0E14;
  --panel: #10151F;
  --border: #1E2530;
  --text: #E7ECF3;
  --muted: #8B96A5;
  --green: #22D3A5;
  --amber: #F0A93A;
  --red: #E5484D;
  background: var(--bg);
  color: var(--text);
  font-family: 'IBM Plex Sans', sans-serif;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity .5s ease, transform .5s ease;
}
.page.is-visible { opacity: 1; transform: translateY(0); }

.status-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 32px;
  background: var(--panel);
  border-bottom: 1px solid var(--border);
  font-family: 'IBM Plex Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.04em;
  color: var(--muted);
  flex-wrap: wrap;
}
.status-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 0 rgba(34,211,165,0.6);
  animation: pulse 2s infinite;
}
@media (prefers-reduced-motion: reduce) { .status-dot { animation: none; } }
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34,211,165,0.5); }
  70% { box-shadow: 0 0 0 6px rgba(34,211,165,0); }
  100% { box-shadow: 0 0 0 0 rgba(34,211,165,0); }
}
.status-text { color: var(--text); }
.status-sep { color: var(--border); }

.eyebrow {
  display: inline-block;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: var(--green);
  margin-bottom: 14px;
}
.eyebrow.center { display: block; text-align: center; }

.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  padding: 72px 32px;
  max-width: 1180px;
  margin: 0 auto;
  flex-wrap: wrap;
}
.hero-left { flex: 1 1 460px; max-width: 620px; }
.hero h1 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.2;
  font-weight: 700;
  margin: 0 0 20px;
}
.lead { color: var(--muted); font-size: 16px; line-height: 1.7; margin-bottom: 32px; }

.cta { display: flex; gap: 14px; flex-wrap: wrap; }
.btn-primary, .btn-secondary {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 13px 22px;
  border-radius: 6px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; border: 1px solid transparent;
  transition: transform .15s ease, background .15s ease;
  font-family: inherit;
}
.btn-primary { background: var(--green); color: #04140F; }
.btn-primary:hover { transform: translateY(-1px); }
.btn-secondary { background: transparent; color: var(--text); border-color: var(--border); }
.btn-secondary:hover { border-color: var(--green); color: var(--green); }

.hero-right { flex: 1 1 380px; display: flex; justify-content: center; }
.panel {
  width: 100%; max-width: 420px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
}
.panel-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
}
.panel-dot { width: 9px; height: 9px; border-radius: 50%; }
.panel-dot.red { background: var(--red); }
.panel-dot.amber { background: var(--amber); }
.panel-dot.green { background: var(--green); }
.panel-title { margin-left: 6px; font-family: 'IBM Plex Mono', monospace; font-size: 12px; color: var(--muted); }
.panel-body { padding: 18px 16px; font-family: 'IBM Plex Mono', monospace; font-size: 13px; }
.log-line { display: flex; align-items: center; gap: 8px; padding: 6px 0; color: var(--muted); }
.log-line.ok svg { color: var(--green); }
.log-line.warn svg { color: var(--amber); }
.cursor { color: var(--green); animation: blink 1s step-end infinite; }
@media (prefers-reduced-motion: reduce) { .cursor { animation: none; } }
@keyframes blink { 50% { opacity: 0; } }

.skills { padding: 72px 32px; text-align: center; max-width: 1180px; margin: 0 auto; }
.skills h2 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(22px, 3vw, 30px);
  margin: 0 0 44px;
}
.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  text-align: left;
}
.skill-card {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 20px;
  transition: border-color .15s ease;
}
.skill-card:hover { border-color: var(--green); }
.skill-head { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; color: var(--green); }
.skill-head h3 { font-size: 14px; color: var(--text); margin: 0; font-weight: 600; }
.skill-card ul { list-style: none; margin: 0; padding: 0; }
.skill-card li {
  font-size: 13px; color: var(--muted);
  padding: 5px 0;
  border-top: 1px solid var(--border);
}
.skill-card li:first-child { border-top: none; }

.cta-section {
  text-align: center;
  padding: 80px 32px;
  border-top: 1px solid var(--border);
}
.cta-section h2 { font-family: 'Space Grotesk', sans-serif; font-size: clamp(22px, 3vw, 28px); margin: 0 0 12px; }
.cta-section p { color: var(--muted); margin-bottom: 28px; }
`;